<template>

<app-view-list-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

	<app-view-common-history :history="history" />

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

	computed: {

		history: function() {

			if (this.isUser && this.item.revisions) {

				return (this.item.revisions) ? this.item.revisions.history : []

			} else {

				return this.item.trend || []

			}

		}

    }

}

</script>

<style scoped>

</style>